import { render } from "./DocumentsPage.vue?vue&type=template&id=62713eed"
import script from "./DocumentsPage.vue?vue&type=script&lang=js"
export * from "./DocumentsPage.vue?vue&type=script&lang=js"

import "./DocumentsPage.vue?vue&type=style&index=0&id=62713eed&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__